import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-scheduled-rides-modal',
    templateUrl: './scheduled-rides-modal.component.html',
    styleUrls: ['./scheduled-rides-modal.component.scss'],
    standalone: true,
    imports: [IonicModule, FormsModule, CommonModule, TranslateModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ScheduledRidesModalComponent implements OnInit {
    selectedDateTime: string;
    minDate: string;
    maxDate: string;

    constructor(private modalCtrl: ModalController) {
        const now = new Date();
        this.minDate = now.toISOString();

        // Allow scheduling up to 7 days in advance
        const max = new Date();
        max.setDate(now.getDate() + 7);
        this.maxDate = max.toISOString();

        // Default to 1 hour from now
        const defaultDate = new Date();
        defaultDate.setHours(now.getHours() + 1);
        this.selectedDateTime = defaultDate.toISOString();
    }

    ngOnInit() { }

    close() {
        this.modalCtrl.dismiss();
    }

    confirm() {
        this.modalCtrl.dismiss({
            scheduledAt: this.selectedDateTime
        });
    }
}
